import { Component, Input } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { DrawerService } from 'src/app/components/drawer.service';

@Component({
  selector: 'app-produce',
  templateUrl: './produce.component.html',
  styleUrls: ['./produce.component.css']
})
export class ProduceComponent {

  @Input() product;
  @Input() productsHeight;

  constructor(private cartService: CartService, private drawerService: DrawerService) { }

  onAddToCart(ID, Name, Price, Picture, Category) {

    const data = {
      _id: ID,
      name: Name,
      price: Price,
      picture: Picture,
      category: Category,
      quantity: 1
    }

    this.cartService.addToCart(data);
    this.drawerService.setDrawerState(true);
  }
}
